import {useSelector,useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {update,selectGuider} from '../state/workoutGuiderSlice'
import {useEvent} from './events'
import {extractExerciseLocationFromRoutine} from '../state/events'

const useWorkoutGuider = ()=>{
	const dispatch = useDispatch()
	const history = useHistory()
	const {
		workout_id,
		exercise_id,
		exercise_type,
		set_id,
		autoPlay,
		setIdx,
		show,
		showCompleted,
		following_workout_id,
		following_exercise_type,
		following_exercise_id
	} = useSelector(selectGuider)

	const workout = useEvent('workout',workout_id)
	const followingWorkout = useEvent('workout',following_workout_id)

	const {exercise: followingExercise} = extractExerciseLocationFromRoutine(
		followingWorkout.routine,
		following_exercise_type,
		following_exercise_id
	)

	const {groupIdx,exerciseIdx,exercise} = extractExerciseLocationFromRoutine(
		workout?.routine,
		exercise_type,
		exercise_id
	)

	const group = groupIdx !== null && workout?.routine[groupIdx]
	const set = exercise?.set_data.find(s=>s.id === set_id)


	const startNextSet = (upNext)=>{
		const nextSetIdx = setIdx + 1
		const nextSetId = exercise.set_data[nextSetIdx].id

		dispatch(update({
			setIdx:nextSetIdx,
			set_id:nextSetId,
			exercise_type,
			exercise_id,
			workout_id,
			autoPlay,
			upNext
		}))

	}
	const startNextSupersetExercise = (upNext)=>{
		const nextExercise = group.exercises[exerciseIdx+1]
		const nextSetId = nextExercise.set_data[setIdx].id

		dispatch(update({
			exercise_id:nextExercise.exercise_id,
			exercise_type:nextExercise.type,
			setIdx:setIdx,
			set_id:nextSetId,
			workout_id,
			autoPlay,
			upNext
		}))
	}
	const startNextSuperset = (upNext)=>{
		const nextExercise = group.exercises[0]
		const nextSetIdx = setIdx + 1
		const nextSetId = nextExercise.set_data[nextSetIdx].id



		dispatch(update({
			exercise_id:nextExercise.exercise_id,
			exercise_type:nextExercise.type,
			setIdx:nextSetIdx,
			set_id:nextSetId,
			workout_id,
			autoPlay,
			upNext
		}))
	}
	const getNextExerciseGroupIdx = (currentGroupIdx)=>{
		for (var i = currentGroupIdx+1; i < workout.routine.length; i++) {
			const routineItem = workout.routine[i]
			if(routineItem.type!=='heading') return i

		}
	}
	const startNextExercise = (upNext)=>{
		const nextExercise = workout.routine[getNextExerciseGroupIdx(groupIdx)].exercises[0]
		const nextSetIdx = 0
		const nextSetId = nextExercise.set_data[nextSetIdx].id



		dispatch(update({
			exercise_id:nextExercise.exercise_id,
			exercise_type:nextExercise.type,
			setIdx:nextSetIdx,
			set_id:nextSetId,
			workout_id,
			autoPlay,
			upNext
		}))
	}
	//WARNING: don't clear out workout_id only the params
	//needed to remove autoplay styling
	const endWorkout = ()=>{
		dispatch(update({
			exercise_type:null,
			exercise_id:null,
			autoPlay:false,
			setIdx:null,
			set_id:null,
			showCompleted:true,
			following_exercise_id: null,
			following_exercise_type: null,
		}))
	}
	const moveToNextSet = (upNext=false)=>{
		const isSuperset = parseInt(exercise.superset) > 0
		if (isSuperset) {
			if(exerciseIdx<group.exercises.length-1){
				startNextSupersetExercise(upNext)
			}else{
				if(setIdx<exercise.set_data.length-1){
					startNextSuperset(upNext)
				}else{
					if(groupIdx<workout.routine.length-1){
						startNextExercise(upNext)
					}else{	
						endWorkout()
					}
				}
			}
		} else {
			if( setIdx < exercise.set_data.length-1 ){
				startNextSet(upNext)
			} else {
				if( groupIdx<workout.routine.length-1 ){
					startNextExercise(upNext)
				}else{	
					endWorkout()
				}
			}
		}//end else
	}//end moveToNextSet
	return {
		updateGuider:update,
		exercise_type,
		showCompleted,
		moveToNextSet,
		exercise_id,
		workout_id,
		exercise,
		followingExercise,
		autoPlay,
		workout,
		set_id,
		setIdx,
		show,
		set
	}
}

export default useWorkoutGuider